import React from 'react';
import BubbleChart from 'components/report-content/components/bubble-chart/BubbleChart';
import BubbleChartEditPanel from 'components/report-content/components/bubble-chart/BubbleChartEditPanel';
import { AbstractComponentBuilder, ComponentSettingsBubbleChart } from '@report-content';

export default class BubbleChartComponentBuilder extends AbstractComponentBuilder<ComponentSettingsBubbleChart> {
    getComponent() {
        return (
            <BubbleChart
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <BubbleChartEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
